<script>
import { Doughnut } from "vue-chartjs";
import "@/plugins/chart";

export default {
    name: "DoughnutChart",
    extends: Doughnut,
    props: {
        title: {
            type: String,
            default: null,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        },
        showPercentage: {
            type: Boolean,
            default: false,
        },
        leyend: {
            type: Boolean,
            default: false,
        },
        centerLines: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets,
            };
        },
        options(vm = this) {
            const theme = vm.$vuetify.theme.currentTheme;
            return {
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 80,
                elements: {
                    arc: {
                        borderWidth: 0,
                    }
                },
                legend: {
                    display: vm.leyend,
                },
                title: {
                    display: !!vm.title,
                    text: vm.title
                },
                layout: {
                    padding: {
                        //
                    }
                },
                tooltips: {
                    backgroundColor: theme.surface2,
                    titleFontColor: theme.txtPrimary,
                    bodyFontColor: theme.txtSecondary,
                    borderColor: theme.outline,
                    borderWidth: 1,
                    cornerRadius: 8,
                    xPadding: 10,
                    yPadding: 8,
                    titleFontFamily: '"Outfit", sans-serif',
                    bodyFontFamily: '"Outfit", sans-serif',
                    callbacks: {
                        label: function(tooltipItem, data) {
                            let label = data.labels[tooltipItem.index] || '';
                            let value = data.datasets[0].data[tooltipItem.index] || 0;
                            if (vm.showPercentage) {
                                value = `${value}%`;
                            }
                            return `${label}: ${value}`;
                        }
                    }
                },
            };
        }
    },
    data() {
        return {
            renderKey: null,
        };
    },
    mounted() {
        const vm = this;
        vm.addPlugin({
            afterDatasetsDraw: chart => {
                if (!vm.centerLines || !vm.centerLines.length) return;
                const ctx = chart.ctx;
                const area = chart.chartArea;
                const cx = (area.left + area.right) / 2;
                const cy = (area.top + area.bottom) / 2;
                const gap = 3;
                const sizes = vm.centerLines.map(l => Number(l.fontSize) || 12);
                const totalH = sizes.reduce((a, b) => a + b, 0) + gap * (vm.centerLines.length - 1);
                let y = cy - totalH / 2;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'top';
                vm.centerLines.forEach((line, i) => {
                    ctx.font = `${line.fontWeight || 600} ${sizes[i]}px "Outfit", sans-serif`;
                    ctx.fillStyle = line.color || '#8892A4';
                    ctx.fillText(line.text, cx, y);
                    y += sizes[i] + gap;
                });
                ctx.restore();
            }
        });
        vm.draw();
    },
    methods: {
        draw() {
            const vm = this;
            const key = JSON.stringify({
                labels: vm.labels,
                data: vm.datasets.map(d => d.data),
                colors: vm.datasets.map(d => d.backgroundColor),
                title: vm.title,
                leyend: vm.leyend,
                showPercentage: vm.showPercentage,
                centerLines: vm.centerLines,
                dark: vm.$vuetify.theme.dark,
            });
            if (key === vm.renderKey) return;
            vm.renderKey = key;
            vm.renderChart(vm.data, vm.options);
        }
    },
    watch: {
        data() {
            this.draw();
        },
        options() {
            this.draw();
        }
    }
};
</script>
